module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/partdetails/partdetails.component.scss
// module id = ./client/app/partdetails/partdetails.component.scss
// module chunks = main